import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourTransition() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  return <section id="start-your-transition" className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden bg-primary">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552867/img/city_skyline_dusk_ocean.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-primary/60" />

      {}
      <div ref={textRef} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-primary-foreground mb-6 tracking-tight">
          Start Your Transition
        </h1>
        
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <Link to="#contact-details" className="flex items-center justify-center w-12 h-12 rounded-full border border-secondary/40 text-secondary hover:bg-secondary/10 transition-colors" aria-label="Scroll down to contact details">
          <ArrowDown className="w-6 h-6" />
        </Link>
      </div>
    </section>;
}